import ContentBanner from './content-banner.component';

export default ContentBanner;
